export default __webpack_public_path__ + "static/media/1000-25_30_38_teakstock.c0330929.jpg";